export const truncateDisplayString = (input: string, numCharacters: number): string => {
  if (input.length > numCharacters) {
    return `${input.slice(0, numCharacters).trim()}...`;
  }

  return input;
};

export default truncateDisplayString;
